import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { SECTION_TITLES, QUICK_ACTIONS_CONFIG } from './constants';
import { QuickActionsCard, QuickActionsTitle, QuickActionsGrid, QuickActionButton } from './styles';

const QuickActionsSection: React.FC = () => {
  const navigate = useNavigate();

  return (
    <QuickActionsCard>
      <QuickActionsTitle>{SECTION_TITLES.QUICK_ACTIONS}</QuickActionsTitle>
      <QuickActionsGrid>
        {QUICK_ACTIONS_CONFIG.map((action) => (
          <QuickActionButton
            key={action.key}
            $accentColor={action.color}
            icon={<FontAwesomeIcon icon={action.icon} />}
            onClick={() => navigate(action.route)}
          >
            {action.label}
          </QuickActionButton>
        ))}
      </QuickActionsGrid>
    </QuickActionsCard>
  );
};

export default QuickActionsSection;
